import React, { useEffect } from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Cookies from 'js-cookie';
import CookieConsent from 'react-cookie-consent';
import TopNavBar from '../components/TopNavBar';
import Footer from '../components/Footer';
import { localeSelector } from '../selectors/i18n';
import { setLocale, DEFAULT_LOCALE, COOKIE_LOCALE } from '../actions/i18n';

const I18n = (WrappedComponent, translations) => (props) => {
    const dispatch = useDispatch();
    const locale = useSelector(localeSelector);
    const cookieLocale = Cookies.get(COOKIE_LOCALE);
    useEffect(() => {
        if (cookieLocale && cookieLocale !== locale) {
            dispatch(setLocale(cookieLocale));
        }
    }, [cookieLocale, dispatch, locale]);
    return (
        <IntlProvider locale={locale} defaultLocale={DEFAULT_LOCALE} messages={translations[locale]}>
            <TopNavBar/>
            <WrappedComponent {...props}/>
            <Footer/>
            <CookieConsent
                buttonText={<FormattedMessage id="cookiebar_allow"/>}
                cookieName="cookiepermission_v1"
                cookieValue="allow"
                style={{ textAlign: 'center', color: '#ffffff', fontSize: '16px' }}
                buttonStyle={{ background: '#006aca', color: '#ffffff', borderRadius: '5px', fontSize: '16px' }}
            >
                <FormattedMessage id="cookiebar_message"/>
                &nbsp;
                <a href={`/${locale}/show/privacy`}>
                    <FormattedMessage id="cookiebar_details"/>
                </a>
            </CookieConsent>
        </IntlProvider>
    );
};

export default I18n;
